import AxiosStatic from "axios";
import { requests } from "./request";

class SubscriptionService {
  $http = AxiosStatic;

  getTrialCountdown() {
    return this.$http
      .post("/api/subscription/TrialCountdown")
      .then((response) => {
        return response.data.trialCountdown;
      })
      .catch(this.formatErrorsAndRethrow);
  }

  updateFreeAccountStatus(freeAccount: boolean, businessID: number) {
    return requests
      .post("/api/subscription/UpdateFreeAccountStatus", {
        freeAccount: freeAccount,
        businessId: businessID
      })
      .catch(this.formatErrorsAndRethrow);
  }

  getAvailableSubscriptionOptions(businessID: Number | null): any {
    return requests
      .get("/api/subscription/GetAvailableSubscriptionOptions" + (businessID ? "?businessID=" + businessID : ""))
      .catch(this.formatErrorsAndRethrow);
  }

  getSubscriptionInformation(businessID: Number | null): any {
    return requests
      .get("/api/subscription/GetSubscriptionInformation" + (businessID ? "?businessID=" + businessID : ""))
      .catch(this.formatErrorsAndRethrow);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private formatErrorsAndRethrow(error: any) {
    if (error.response) {
      let err = error.response.data;
      if (err.errors) {
        err = [
          ...Object.keys(error.response.data.errors).map(
            (key) => error.response.data.errors[key]
          ),
        ];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        err = err.reduce((flat: any, list: any) => flat.concat(list));
        console.log(err);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        err = err.reduce((val: any, arr: any) => `${val} \r\n${arr}`, "");
      }
      throw new Error(err);
    } else {
      throw new Error("An unexpected error has occurred");
    }
  }
}

export default new SubscriptionService();
